// extracted by mini-css-extract-plugin
export var menuItem = "H_v5 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "H_v6 d_Z d_bz d_bP";
export var menuMainLink = "H_v7 d_f0 d_dB";
export var menuLink = "H_v8 d_f0 d_dB";
export var icon = "H_p9 d_bC d_bP";
export var divider = "H_v9 d_bC d_bP";
export var sublinks = "H_wb";
export var link = "H_mC";
export var Link = "H_vH G_vH G_t4 G_vp";